import { z } from "zod";

export const ButtonSizeSchema = z.union([z.literal("small"), z.literal("medium"), z.literal("large")]);
